export class CivilCaseUtils {

    public static convertToNumber(jsonField: string): number {
        if (jsonField === '') {
            return 0;
        }
        const num = Number.parseInt(jsonField);
        return num;
    }

    public static formatNumberToCurrency(value: number): string {
        let formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
        });
        return formatter.format(value); /* $2,500.00 */
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-case-utils.ts